<template>
  <div class="container-wrapper">
    <div class="container">
      <div class="error-code">404</div>
      <div class="error-code-message">Oops, Page Not Found</div>
      <div class="error-code-description">
        Page that you're looking for isn't found
      </div>
      <div class="btn">
        <nuxt-link to="/">Go Back</nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
body {
  &.ffa-app {
    --brand-color-light: #3c55ae;
    --brand-color-dark: #1a2a6c;
  }
  &.ocean-app {
    --brand-color-light: #0e664a;
    --brand-color-dark: #053d28;
  }
}
</style>
<style lang="less" src="./404.less" scoped></style>
